export interface ProductCompanyBadge {
  name: string
  logoSrc: string
}

const COMPANY_BADGES: Record<number, ProductCompanyBadge> = {
  1: { name: 'Index', logoSrc: '/images/index-logo.png' },
  1000: { name: 'Index', logoSrc: '/images/index-logo.png' },
  2: { name: 'Netex', logoSrc: '/images/netex_logo.png' },
  2300: { name: 'Netex', logoSrc: '/images/netex_logo.png' },
  3: { name: 'Despec', logoSrc: '/images/despec_logo.png' },
  1200: { name: 'Despec', logoSrc: '/images/despec_logo.png' },
  4: { name: 'Datagate', logoSrc: '/images/datagate_logo.png' },
  1100: { name: 'Datagate', logoSrc: '/images/datagate_logo.png' },
}

/** Only known portal company ids receive a visual badge; unknown values stay hidden. */
export function getProductCompanyBadge(companyId?: number | null): ProductCompanyBadge | null {
  return companyId === undefined || companyId === null ? null : COMPANY_BADGES[companyId] ?? null
}
